/*
    Ссылка «Close Project» на странице кейса:
    если перешли с другой страницы, подставляем
    ссылку на неё, чтобы вернуться на ту же страницу
*/

class BackLink {
    constructor(el) {
        this.$link = $(el);
        this.bind();
    }

    bind() {
        const prev = barba.history.previous;

        if (prev) {
            this.$link.attr('href', prev.url);
        }
    }
}

App.W.on('barba:afterEnter', () => {
    App.H.find('.js-close-project').each(function() {
        new BackLink(this);
    });
});



// WEBPACK FOOTER //
// ./_src/js/modules/BackLink.js